<template>
	<div v-show="isShow" class="fixed_block" @click="handleClick">
		<p class="title ellipsis2">{{ infoData.noticeTitle }}</p>
		<i class="el-icon-close" @click.stop="isShow = false"></i>
	</div>
</template>

<script>
import {getNoticeListApi} from "@/api";

export default {
	name: "index",
	data() {
		return {
			isShow: false,
			infoData: {},
			timer: null,
		}
	},
	created() {
		this.init();
	},
	methods: {
		async init() {
			const res = await getNoticeListApi();
			this.infoData = res.data[0] ? res.data[0] : {};

			if(this.infoData.youxiao_time) {
				this.startTimer();
			}else {
				this.isShow = false;
			}

		},

		/**
		 * 判断此数据是否 超过 有效期
		 */
		getDateToTerm(time) {
			time = new Date(time).getTime();
			let curTime = new Date().getTime();
			return time > curTime
		},

		startTimer() {
			this.closeTimer();
			this.isShow = !!this.getDateToTerm(this.infoData.youxiao_time);
			this.timer = setTimeout(() => {
				this.isShow = !!this.getDateToTerm(this.infoData.youxiao_time);
			}, 1000)
		},
		closeTimer() {
			if(this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
		},

		handleClick() {
			this.$router.push("/notice/" + this.infoData.noticeId)
		},
	},
	beforeDestroy() {
		this.closeTimer();
	}
}
</script>

<style lang="less" scoped>
.fixed_block {
	width: 280px;
	height: 120px;
	position: fixed;
	bottom: 180px;
	right: 0;
	background-image: url("~@/assets/fixed_block_bg.jpg");
	background-repeat: no-repeat;
	background-size: 100% 100%;
	z-index: 99999;
	cursor: pointer;
	padding: 44px 100px 0 20px;

	.title {
		font-size: 20px;
		color: @white;
	}

	.el-icon-close {
		font-size: 16px;
		color: @white;
		text-shadow: 2px 2px 2px #343434;
		position: absolute;
		top: 6px;
		right: 6px;
	}
}
</style>
